
import Vue from "vue";
import dayjs from "dayjs";

export default Vue.extend({
  props: {
    BarrelStatus: {
      type: String,
      required: true,
    },
    StatusDate: {
      type: String,
      required: true,
    },
  },
  computed: {
    status() {
      return this.BarrelStatus.replaceAll("_", " ");
    },
    date() {
      return dayjs(this.StatusDate).format("dddd, MMMM D, YYYY h:mm A");
    },
  },
});
